import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import {connect} from "react-redux";
import {HeaderBand, redirect} from "../../helpers";
import {useHistory} from "react-router";
import CardActionArea from '@material-ui/core/CardActionArea';
import ReactHtmlParser from "react-html-parser";

const useStyles = makeStyles({
    card: {
        minWidth: 275,
    }
});
const firstTitle = (title,tooltip, dark) => <div>
    <Typography variant="h6"
                style={{color : dark ? "#eeeeee" :"#0f69b4", textAlign: window.innerWidth <= 768 ? "center" : "left"}}
                className="mb-3">{ title }
        &nbsp;{!!tooltip && showTooltip(tooltip)}
    </Typography>
</div>;

const firstTitleLink = ({text, direction},history, dark) => <Card className="rounded-lg my-2" style={{
    backgroundColor: dark ? "#4A4A4A":"#EEEEEE",
    }}>
    <CardActionArea className="pl-2 pt-2" onClick={() => redirect(direction,history)}>
    <Typography variant="subtitle1"
                style={{color : dark ? "#eeeeee" :"#0f69b4", textAlign: window.innerWidth <= 768 ? "center" : "left"}}
                className="mb-3"><strong>{ text }</strong>
    </Typography>
    </CardActionArea>
</Card>;

const subtitle = (text, dark) => <p className={`${dark? "text-white-50": ""}`} > {text} </p>;

const titleDesc = (items, dark) =><div>
    { items.map((item, key) =>
        <div key={key}><p className="mb-0" style={{color : dark ? "#eeeeee" :"#0f69b4"}}>{item.title}</p>
            <p  className={`text-justify ${dark? "text-white-50": ""}`}>
                {
                    !!item.text && item.text.includes("<" || ">") ? ReactHtmlParser(item.text) : item.text
                }
            </p>
        </div>)}
</div>;

const underlineTitle = (items, dark) => <div>
    {items.map((item, key) =><div key={key}>
        <dt><u className=""
               onClick={() => !!item.link ? redirect(item.link,{},true) : null}
               style={{
                   color : dark ? "#eeeeee" :"#0f69b4",
                   textAlign: window.innerWidth <= 768 ? "center" : "left",
                    cursor: item.link ? "pointer":null
        }} >{item.title}</u></dt>
        <dd className={`${dark? "text-white-50": ""}`} >
            {
                !!item.text && item.text.includes("<" || ">") ? ReactHtmlParser(item.text) : item.text
            }
        </dd>
    </div>)}
</div>;


const numeratedList = (list, dark) => <div>
    <ol className={`pl-3 ${dark? "text-white-50": ""}`} >
        { list.map((item, key) => <li key={key}>{item}</li>) }
    </ol>
</div>;

const headerBand = () => <HeaderBand />


const showTooltip = (text) => <a href="#" className="tooltip-new"><img src="assets/imagenes/info-icon.png" width="20" height="20" alt="tooltip"/><span> { text } </span></a>;


const TextCardMaterial = props => {
    const classes = useStyles();
    let history = useHistory();
    const { hasHeaderBand,tooltip, leftSide, rightSide, dark } = props;
    return(<Card className={`${classes.card} mb-4 mt-2`} >
            <CardContent className="py-0 my-0 w-100 px-0 pb-1 m-sm-auto">
                <div>
                    {  hasHeaderBand && headerBand() }
                    <div className="card-banner">
                        <div className="row mx-0">
                            <div className="col-md-7 mt-3 linea-separacion-columnas">
                                { leftSide.firstTitle &&  firstTitle(leftSide.firstTitle, tooltip, dark) }
                                { leftSide.titleDescB && titleDesc(leftSide.titleDescB, dark)}
                                { leftSide.subtitle && subtitle(leftSide.subtitle, dark) }
                                { leftSide.numeratedList && numeratedList(leftSide.numeratedList, dark)}
                                { leftSide.titleDesc && titleDesc(leftSide.titleDesc, dark) }
                                { leftSide.underlineTitle && underlineTitle(leftSide.underlineTitle, dark)}
                                { leftSide.firstTitleLink && firstTitleLink(leftSide.firstTitleLink, history, dark)}
                            </div>
                            <hr className="w-100 d-md-none"/>
                            <div className="col-md-5 mt-4">
                                <dl>
                                    { rightSide.titleDescB && titleDesc(rightSide.titleDescB, dark)}
                                    { rightSide.numeratedList && numeratedList(rightSide.numeratedList, dark)}
                                    { rightSide.titleDesc && titleDesc(rightSide.titleDesc, dark)}
                                    { rightSide.underlineTitle && underlineTitle(rightSide.underlineTitle, dark)}
                                    { rightSide.firstTitleLink && firstTitleLink(rightSide.firstTitleLink, history, dark)}
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </CardContent>
        </Card>
    );
}

TextCardMaterial.propTypes = {
    hasHeaderBand: PropTypes.bool,
    image: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    links: PropTypes.array
};

const mapStateToProps = state => ({
    dark : state.dark
})

export default connect(mapStateToProps, {})(TextCardMaterial);
